<template>
  <div>
    <van-nav-bar
      fixed
      left-arrow
      :safe-area-inset-top="true"
      @click-left="leftBut"
    >
      <template #title>
        <span style="fontsize: 18px; fontweight: 700; color: #333">
          忘记密码
        </span>
      </template>
    </van-nav-bar>
    <van-form @submit="onSubmit" class="login_form">
      <van-field
        class="input_tel"
        v-model="phone"
        type="tel"
        label="手机号"
        clearable
        placeholder="请填写手机号"
        :rules="[{ required: true }]"
      />
      <van-field
        class="input_code"
        v-model="code"
        type="number"
        label="验证码"
        placeholder="请填写验证码"
        maxlength="6"
        :rules="[{ required: true }]"
      >
        <span slot="right-icon" :class="['tel_code', keyFlag ? '' : 'fontColor' ]" @click="getCode">{{
          keyFlag ? "获取验证码" : num + "秒后重新获取"
        }}</span>
      </van-field>
      <van-field
        class="input_pas"
        v-model="password"
        type="password"
        label="新密码"
        placeholder="设置新密码（6-16个数字、字母组合）"
        :rules="[{ required: true }]"
      />
      <div style="margin: 50vh 30px 20px 0">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          class="form_btn"
          >确认</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import { NavBar, Field, Form, Toast } from "vant";
export default {
  name: "forgetPas",
  components: {
    "van-form": Form,
    "van-nav-bar": NavBar,
    "van-field": Field,
  },
  data() {
    return {
      phone: "",
      password: "",
      code: "",
      num: 59,
      keyFlag: true,
    };
  },
  methods: {
    // 左侧按钮(gubeit为协商的方法名)
    leftBut() {
      window.history.go(-1);
    },
    // 提交表单
    async onSubmit() {
      const telRegExp = new RegExp("^1[35789]\\d{9}$");
      const pasRegExp = new RegExp(
        "^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$"
      );
      if (!telRegExp.test(this.phone)) {
        Toast("请填写正确的手机号");
      } else if (!pasRegExp.test(this.password)) {
        Toast("请设置新密码（6-16个数字、字母组合）");
      } else {
        let obj = {
          mobile: this.phone,
          pwd: this.password,
          validateCode: this.code,
        };
        let res = await this.$apis.loginServe.repwd(obj);
        if (res.resultCode !== "200") {
          Toast(res.resultDesc);
          return;
        }
        Toast("修改成功");
        this.leftBut()
      }
    },
    // 获取验证码
    async getCode() {
      if (!this.keyFlag) return;
      if (this.phone) {
        var regExp = new RegExp("^1[35789]\\d{9}$");
        if (regExp.test(this.phone)) {
          const res = await this.$apis.loginServe.getCode({
            phone: this.phone,
            adapter: "retrieve_pwd",
          });
          if (res.resultCode == "200") {
            Toast("获取成功");
            this.keyFlagChange();
          } else {
            Toast("获取失败,请重新获取");
          }
        } else {
          Toast("请填写正确的手机号");
        }
      } else {
        Toast("请填写手机号");
      }
    },
    // 获取验证码时间
    keyFlagChange() {
      this.keyFlag = false;
      let timer = setInterval(() => {
        if (this.num <= 0) {
          clearInterval(timer);
          this.keyFlag = true;
          this.num = 59;
        } else {
          this.num = --this.num;
        }
      }, 1000);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .van-nav-bar__content {
  height: 71px;
  border-bottom: 1px solid #dcdcdc;
}
::v-deep .van-icon-ellipsis:before {
  font-size: 25px;
  color: #333;
}
::v-deep .van-icon-arrow-left:before {
  font-size: 20px;
  color: #333;
}
.login_form {
  margin-top: 75px;
  padding-left: 21px;
  .van-field {
    padding: 24px 20px 11px 0;
  }
  &::v-deep .van-field__label {
    font-weight: 700;
    font-size: 14px;
    color: #333333;
  }
  .van-cell::after {
    right: 0;
    left: 0;
    border-bottom: 1px solid #bfbfbf;
    opacity: 0.75;
  }
  .input_code {
    .tel_code {
      font-size: 14px;
      color: #284fce;
    }
    .fontColor {
      color: #999;
    }
  }
  .form_btn {
    height: 40px;
    background: linear-gradient(0deg, #6883ff 0%, #536dfe 100%);
    .van-button__text {
      font-size: 19px;
      font-weight: 700;
      color: #ffffff;
      letter-spacing: 5px;
    }
  }
}
</style>
